import { invokeService } from '@alife/tarot';
const initData = {
  mkcInfo: null,
  isLoading: false,
  success: false,
  formParams: {
    ptid : window.p4pObject && window.p4pObject.ptid || ""
  }
};
const Module = {
  name: 'mkc',
  initState: initData,
  reducers: {
    setParams(state, action) {
      return {
        ...state,
        formParams: {
          ...state.formParams,
          ...action.payload
        }
      }
    },
    resetData() {
      return initData;
    },
    resetList(state) {
      return {
        ...state,
        mkcInfo: null
      }
    }
  },
  effects: {
    * getList(actions, { put, call }, state) {
      const payload = Object.assign({}, state.formParams, actions.payload);
      yield put("mkc/setValues", {
        isLoading: true
      });
      try {
        const result = yield call(invokeService, 'getOfferPromotionList', payload);
        const {content} = result.body.data;
        const {success} = result.body.data;
        if (success) {
          // 数据更新依然需要交给 reducer
          yield put("mkc/setValues", {
            mkcInfo: Object.assign({}, state.mkcInfo, content),
            isLoading: false,
            success
          });
        } else {
          yield put("mkc/setValues", {
            isLoading: false,
            success
          });
        }

      } catch (e) {
        yield put("mkc/setValues", {
          isLoading: false
        });
        throw e;
      }
    }
  }
};

export default Module;
